import React from "react";
import { Loader } from "../Loader";
import { createPortal } from "react-dom";

function FullScreenLoader() {
  return createPortal(
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[99]">
      <Loader />
    </div>,
    document.getElementById("root")
  );
}

export default FullScreenLoader;
